import script from "./ManageBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBooking.vue?vue&type=script&setup=true&lang=js"

import "./ManageBooking.vue?vue&type=style&index=0&id=64e92942&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e92942"]])

export default __exports__